export type CallNotification = {
  recipientId: string
  callNotice: { callId: string; callerId: string; media: 'audio' | 'video'; expiresAt: string }
}

// Notifications are navigation hints. Only authenticated server state can
// create a real incoming call or supply SDP and confirm it is still ringing.
let pending: CallNotification | null = null
export function callNotification(data: Record<string, unknown> | undefined): CallNotification | null {
  const notice = data?.callNotice
  if (!data || typeof data.recipientId !== 'string' || !data.recipientId || !notice || typeof notice !== 'object') return null
  const value = notice as Record<string, unknown>
  if (typeof value.callId !== 'string' || !/^[a-zA-Z0-9_-]{1,100}$/.test(value.callId)
    || typeof value.callerId !== 'string' || !value.callerId || value.callerId === data.recipientId
    || (value.media !== 'audio' && value.media !== 'video')
    || typeof value.expiresAt !== 'string' || !Number.isFinite(Date.parse(value.expiresAt)) || Date.parse(value.expiresAt) <= Date.now()) return null
  return { recipientId: data.recipientId, callNotice: { callId: value.callId, callerId: value.callerId, media: value.media, expiresAt: value.expiresAt } }
}
export function queueCallNotification(data: Record<string, unknown> | undefined): CallNotification | null {
  pending = callNotification(data)
  return pending
}
export function takeCallNotification(recipientId: string): CallNotification | null {
  const notice = pending
  pending = null
  return notice?.recipientId === recipientId ? callNotification(notice) : null
}
